const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
const NUMERIC_ONLY_RE = /^\d+$/
const INVALID_SENTINELS = new Set(['', 'faq', 'nan', 'null', 'undefined'])

const parseBuyerIntentId = value => {
  if (value == null) {
    return null
  }

  const normalizedValue = String(value).trim()

  if (INVALID_SENTINELS.has(normalizedValue.toLowerCase())) {
    return null
  }

  if (NUMERIC_ONLY_RE.test(normalizedValue)) {
    return null
  }

  if (!UUID_RE.test(normalizedValue)) {
    return null
  }

  return normalizedValue
}

export const normalizeBuyerIntentId = value => parseBuyerIntentId(value)

export const normalizeBuyerIntentIds = values => {
  if (!Array.isArray(values) || values.length === 0) {
    return []
  }

  return values.map(value => parseBuyerIntentId(value)).filter(value => value !== null)
}
